import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getVideoByVideoIdRpc, getVideoByFileIdRpc } from '../../__generated__/chirp/com/hubspot/video/rpc/HubSpotVideoRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function fetchVideo2(videoId) {
  return rpcClient.call(getVideoByVideoIdRpc, {
    request: {
      videoId
    }
  });
}
export function fetchVideoByFileId(id) {
  return rpcClient.call(getVideoByFileIdRpc, {
    request: {
      sourceFileId: id
    }
  });
}
const MAX_TRIES = 10;
const POLL_INTERVAL_MS = 1000;
export function pollForUploadedVideo(fileId) {
  let tries = 0;
  let timeout;
  return new Promise((resolve, reject) => {
    const tryFetch = () => {
      fetchVideoByFileId(fileId).then(data => {
        clearTimeout(timeout);
        resolve(data);
      }).catch(err => {
        tries++;
        if (tries < MAX_TRIES) {
          timeout = setTimeout(tryFetch, POLL_INTERVAL_MS);
        } else {
          reject(err);
        }
      });
    };
    timeout = setTimeout(tryFetch, POLL_INTERVAL_MS);
  });
}